<template>
  <ConfigProvider
    :locale="getAntdLocale"
    :theme="
      isDark
        ? {
            ...darkTheme,
            ...themeColor,
          }
        : themeColor
    "
  >
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import { AppProvider } from '@/components/Application';
  import { useTitle } from '@/hooks/web/useTitle';
  import { useLocale } from '@/locales/useLocale';
  import { ConfigProvider } from 'ant-design-vue';

  import { useDarkModeTheme } from '@/hooks/setting/useDarkModeTheme';
  import 'dayjs/locale/zh-cn';

  // support Multi-language
  const { getAntdLocale } = useLocale();

  const { isDark, darkTheme } = useDarkModeTheme();

  const themeColor = {
    token: {
      colorPrimary: '#5D5FEF',
    },
  };
  // Listening to page changes and dynamically changing site titles
  useTitle();
</script>
